import { useContext } from "react"
import { UserContext } from "../context"
import AuthUser from "../models/auth-user"

export default (): undefined | AuthUser => {
  const { loggedInUser } = useContext(UserContext)
  return loggedInUser
}
